/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateExpenseItemInput = {
    projectId?: string | null | undefined;
    companyProjectId?: number | null | undefined;
    name?: string | null | undefined;
    billable?: boolean | null | undefined;
    partOfFixedPrice?: boolean | null | undefined;
    cost?: number | null | undefined;
    price?: number | null | undefined;
    quantity?: number | null | undefined;
    approved?: boolean | null | undefined;
    expenseYear?: number | null | undefined;
    expenseMonth?: number | null | undefined;
    expenseDay?: number | null | undefined;
    planned?: boolean | null | undefined;
    notes?: string | null | undefined;
    personId?: string | null | undefined;
    expenseCategoryId?: string | null | undefined;
    phaseId?: string | null | undefined;
    xeroPurchaseOrderId?: string | null | undefined;
    sageIntacctPurchaseOrderId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createExpenseItemMutationVariables = {
    input: CreateExpenseItemInput;
};
export type createExpenseItemMutationResponse = {
    readonly createExpenseItem: {
        readonly expenseItem: {
            readonly node: {
                readonly id: string;
                readonly category: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
                readonly name: string | null;
                readonly approved: boolean | null;
                readonly expenseYear: number | null;
                readonly expenseMonth: number | null;
                readonly expenseDay: number | null;
                readonly billable: boolean | null;
                readonly partOfFixedPrice: boolean | null;
                readonly price: number | null;
                readonly cost: number | null;
                readonly quantity: number | null;
                readonly planned: boolean | null;
                readonly createdAt: string | null;
                readonly person: {
                    readonly id: string;
                    readonly fullName: string | null;
                    readonly profilePictureId: string | null;
                    readonly profilePictureDefaultId: number | null;
                } | null;
                readonly project: {
                    readonly id: string;
                    readonly companyProjectId: number | null;
                    readonly customProjectId: string | null;
                    readonly name: string | null;
                } | null;
                readonly phase: {
                    readonly id: string;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type createExpenseItemMutation = {
    readonly response: createExpenseItemMutationResponse;
    readonly variables: createExpenseItemMutationVariables;
};



/*
mutation createExpenseItemMutation(
  $input: CreateExpenseItemInput!
) {
  createExpenseItem(input: $input) {
    expenseItem {
      node {
        id
        category {
          id
          name
        }
        name
        approved
        expenseYear
        expenseMonth
        expenseDay
        billable
        partOfFixedPrice
        price
        cost
        quantity
        planned
        createdAt
        person {
          id
          fullName
          profilePictureId
          profilePictureDefaultId
        }
        project {
          id
          companyProjectId
          customProjectId
          name
        }
        phase {
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateExpenseItemInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExpenseItemPayload",
    "kind": "LinkedField",
    "name": "createExpenseItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpenseItemTypeEdge",
        "kind": "LinkedField",
        "name": "expenseItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ExpenseItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approved",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expenseYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expenseMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expenseDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partOfFixedPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "planned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profilePictureId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profilePictureDefaultId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyProjectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customProjectId",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PhaseType",
                "kind": "LinkedField",
                "name": "phase",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createExpenseItemMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createExpenseItemMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createExpenseItemMutation",
    "operationKind": "mutation",
    "text": "mutation createExpenseItemMutation(\n  $input: CreateExpenseItemInput!\n) {\n  createExpenseItem(input: $input) {\n    expenseItem {\n      node {\n        id\n        category {\n          id\n          name\n        }\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        cost\n        quantity\n        planned\n        createdAt\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        project {\n          id\n          companyProjectId\n          customProjectId\n          name\n        }\n        phase {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '804d7628c674fd4b68c69ab3548e3294';
export default node;
